import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { parsePaneSearch } from "../../screens/source/search.ts";
import { ThreadPage } from "../../screens/threads/ThreadPage.tsx";

/** `/threads/$threadId`: one conversation with Adea, on its own page. */
export const Route = createFileRoute("/_app/threads/$threadId")({
  validateSearch: parsePaneSearch,
  loader: ({ context, params }) =>
    context.queryClient.prefetchQuery(actions.queryOptions("threads.get", { threadId: params.threadId })),
  component: ThreadPage,
});
